export enum SpinnerType {
    Spring = 0,
    Semipolar = 1,
    FulfillingBouncingCircle = 2,
    Radar = 3,
    TrinityRings = 4,
    HalfCircle = 5,
    ScalingSquares = 6,
    SwappingSquares = 7,
}
